import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import NavigationMobile from './components/navigation/NavigationMobile';
import Main from './components/home/Main';
import MainMobile from './components/home/MainMobile';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import TermsOfUse from './components/terms/TermsOfUse';
import SoftwareTerms from './components/terms/SoftwareTerms';
import BookDemo from './components/demo/BookDemo';
import RuntimeShield from './components/runtime/RuntimeShield';
import RuntimeShieldMobile from './components/runtime/RuntimeShieldMobile';
import PurpleTeam from './components/purpleteam/PurpleTeam';
import PurpleTeamMobile from './components/purpleteam/PurpleTeamMobile';
import Workspace from './components/workspace/Workspace';
import WorkspaceMobile from './components/workspace/WorkspaceMobile';
import WorkspaceDemo from './components/workspace/WorkspaceDemo';
import Resources from './components/resources/Resources';
import ResourcesMobile from './components/resources/ResourcesMobile';
import CodingAgentsGuide from './components/resources/CodingAgentsGuide';
import MCPConnectionsGuide from './components/resources/MCPConnectionsGuide';
import BlogPost from './components/resources/BlogPost';
import BlogPostMobile from './components/resources/BlogPostMobile';
import UseCases from './components/usecases/UseCases';
import UseCaseBanking from './components/use_cases/UseCaseBanking';
import UseCaseLegal from './components/use_cases/UseCaseLegal';
import UseCaseMedical from './components/use_cases/UseCaseMedical';
import UseCaseHospitality from './components/use_cases/UseCaseHospitality';
import Company from './components/company/Company';
import Partner from './components/partner/Partner';
import PartnerApply from './components/partner/PartnerApply';
import PartnerLogin from './components/partner/PartnerLogin';
import PartnerDashboard from './components/partner/PartnerDashboard';
import DealRegistration from './components/partner/DealRegistration';
import ContactUs from './components/contact/ContactUs';
import Footer from './components/footer/Footer';
import StatusPage from './components/status/StatusPage';
import ScrollToTop from './components/ScrollToTop';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
}

function AppShell() {
  const isMobile = useIsMobile();
  // Admin routes stand alone — no marketing nav/footer (they render their own header).
  const isAdmin = window.location.pathname.startsWith('/admin');
  // So does /status, for a stronger reason: it is read when the rest of the
  // site may be having a bad day, and it should not invite someone mid-outage
  // to go browsing marketing pages.
  const isStatus = window.location.pathname.startsWith('/status');
  const bare = isAdmin || isStatus;
  return (
    <div className="app">
      {!bare && (isMobile ? <NavigationMobile /> : <Navigation />)}
      <main>
          <Routes>
            <Route path="/" element={isMobile ? <MainMobile /> : <Main />} />
            <Route path="/status" element={<StatusPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/software-terms" element={<SoftwareTerms />} />
            <Route path="/book-demo" element={<BookDemo />} />
            <Route path="/runtime-shield" element={isMobile ? <RuntimeShieldMobile /> : <RuntimeShield />} />
            <Route path="/purple-team" element={isMobile ? <PurpleTeamMobile /> : <PurpleTeam />} />
            <Route path="/ai-governance" element={isMobile ? <WorkspaceMobile /> : <Workspace />} />
            <Route path="/workspace-demo" element={<WorkspaceDemo />} />
            <Route path="/resources" element={isMobile ? <ResourcesMobile /> : <Resources />} />
            <Route path="/resources/coding-agents" element={<CodingAgentsGuide />} />
            <Route path="/resources/app-mcp-connections" element={<MCPConnectionsGuide />} />
            <Route path="/resources/:slug" element={isMobile ? <BlogPostMobile /> : <BlogPost />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/use-cases/banking" element={<UseCaseBanking />} />
            <Route path="/use-cases/legal" element={<UseCaseLegal />} />
            <Route path="/use-cases/medical" element={<UseCaseMedical />} />
            <Route path="/use-cases/hospitality" element={<UseCaseHospitality />} />
            <Route path="/company" element={<Company />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/partner/apply" element={<PartnerApply />} />
            <Route path="/partner/login" element={<PartnerLogin />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/partner/deals/new" element={<DealRegistration />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>
        {!bare && <Footer />}
        <Analytics />
        <SpeedInsights />
      </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
